import React from 'react';
import '../../Styles/MainRoutes.scss';
import { BrowserRouter as Router, Routes, Route, Link, RouterProvider} from 'react-router-dom';
import { pagesRoutes } from '../../Constant/index.js';
import Error from './Error';
import { SelectedBike } from '../../Constant/context';
import { useState } from 'react';

function MainRoutes() {

   const [selectedBikeGlobal, setSelectedBikeGlobal] = useState({
      'number': '',
      'selected': false,
      'name': '',
      'price': '',
      'picture': '',
   });
   const [selectedDateGlobal, setSelectedDateGlobal] = useState({
      'startDate': 'YYYY.MM.DD',
      'finishDate': 'YYYY.MM.DD',
      'amountDays': '0',
      'typeRent': 'Days',
      'delivery': 'Pick up delivery',
      'sumPrice': '0',
      'payment': 'Online',
   });
   const [arrayOfBikes, setArrayOfBikes] = useState([]);
   
   const [orderedDateGlobal, setOrderedDateGlobal] = useState([]);

   return (
      <div className='main__wrapper'>
         <SelectedBike.Provider value={{
            selectedBikeGlobal,
            setSelectedBikeGlobal,
            arrayOfBikes,
            setArrayOfBikes,
            selectedDateGlobal,
            setSelectedDateGlobal,
            orderedDateGlobal,
            setOrderedDateGlobal,
         }}>
            <Routes>
               {pagesRoutes.map((route, index) => 
                  <Route
                     key={index}
                     element={route.element}
                     path={route.path}
                     exact={route.exact}
                  />
               )}
               <Route path='*' element={<Error/>} />
            </Routes>
         </SelectedBike.Provider>
      </div>
   );
}
export default MainRoutes;